var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.783 2.707L3 10.49v2.548l2.252-.25 7.806-7.806-2.275-2.275zm-.589-.825a.833.833 0 011.179 0l2.51 2.51a.833.833 0 010 1.179l-7.965 7.965a.833.833 0 01-.497.239l-2.496.277A.833.833 0 012 13.224v-2.803c0-.22.088-.433.244-.589l7.95-7.95z"
  })));
}
export default SvgEditPencilIcon;